"use client";
import React, { useMemo } from "react";
import { CircledIcon } from "../CircledIcon";
import FacebookIcon from "@/assets/icons/logo-facebook.svg";
import TwitterIcon from "@/assets/icons/logo-twitter.svg";
import EndemicLogo from "@/assets/icons/endy/endy-empty.svg";
import Link from "next/link";
import {
  getFacebookShareLink,
  getTwitterShareLink,
  openLinkInDialog,
} from "@/shared/social";
import { publicConfig } from "@shared/config/constants";

export interface Props {
  className?: string;
  nftId: string;
}

const ShareSection = ({ className, nftId }: Props) => {
  const nftUrl = useMemo(() => `${publicConfig.url}/nft/${nftId}`, [nftId]);

  const handleFacebookShareClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openLinkInDialog(getFacebookShareLink(nftUrl));
  };

  return (
    <div className={className}>
      <div className="text-body-2 text-center mb-4">Share:</div>
      <div className="flex gap-4 justify-center">
        <Link
          href={getFacebookShareLink(nftUrl)}
          onClick={handleFacebookShareClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          <CircledIcon
            className="border-endemicGray night:fill-white night:border-white"
            icon={<FacebookIcon className="w-5 h-5" />}
          ></CircledIcon>
        </Link>
        <Link
          href={getTwitterShareLink(nftUrl)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <CircledIcon
            className="border-endemicGray night:fill-white night:border-white"
            icon={<TwitterIcon className="w-6 h-6" />}
          ></CircledIcon>
        </Link>
        <Link href={`${publicConfig.url}/feed/global?attachedNftId=${nftId}`}>
          <CircledIcon
            className="border-endemicGray night:fill-white night:border-white"
            icon={
              <EndemicLogo className="w-6 h-6 fill-black night:fill-white" />
            }
          ></CircledIcon>
        </Link>
      </div>
    </div>
  );
};

export default ShareSection;
